module.exports = "/assets/gift-events-listing/WR_banner_desktop-cz.png?Key+7H1";